const GraphNetecs = require('graph-netecs/js/GraphNetecs').GraphNetecs;
const PolynomialLine = require('graph-netecs/js/PolynomialLine').PolynomialLine;
const Polynomial = require('mathFunctions/js/Polynomial').Polynomial;
const VerticalLine = require('graph-netecs/js/VerticalLine').VerticalLine;

class resistanceTorque {
    constructor(html, store, data, createGraphLine = true) {
        if (html) {
            this.html = html;
        }
        this.store = store;
        this.data = data;
        this.unitsList = window.unitsList;

        let graph = new GraphNetecs(this.unitsList, createGraphLine);
        this.html.append(graph.html);

        let lineFowColor = '#2b6cb3'; //kolory wykresów
        let lineFowzColor = 'green';

        //pobieram dane z data
        let powerOnShaftWithMaterial = this.store.state.workPointParameters.elements.power_on_shaft_with_material.value || this.store.state.workPointParameters.elements.power_on_shaft.value || 0;
        powerOnShaftWithMaterial = powerOnShaftWithMaterial / this.data.params.number_of_fans;
        let ratedSpeed = this.data.params.start_time.rated_speed;
        let powerOnShaftMin = this.data.params.start_time.power_on_shaft_min;
        let graphScale = (ratedSpeed > this.data.params.start_time.engine_speed) ? ratedSpeed : this.data.params.start_time.engine_speed;

        let xMin = 0;
        let xMax = 1.02;
        let xDivider = .05; //podział wykresu przy tym x, przed nim liniowa, za nim parabola

        //oś y
        graph.graph.config.y.step = Math.floor(ratedSpeed / 100); //skalowanie osi - do ewentualnej poprawy
        graph.graph.config.y.titleHTML = '';
        
        //oś x
        graph.graph.config.x.step = Math.floor(ratedSpeed / 100) / (ratedSpeed / 4000);
        graph.graph.config.x.titleHTML = '';
        // NVS-90 - zmiana jednostki na osi x
        graph.graph.config.x.unit = unitsList.rotationSpeed.list[0];
        graph.graph.config.x.unit.a1d = graphScale;

        //obliczenia
        let Mow = 9550 * (powerOnShaftWithMaterial / ratedSpeed); //moment przy otwartej zasuwie
        let Mowz = 9550 * (powerOnShaftMin / ratedSpeed); //moment przy zamkniętej zasuwie
        // let p = ratedSpeed * xDivider; //wierzchołek paraboli - okazuje się, że wykres ma nie być ciągły...
        let p = 0;
        let fow = 9550 * powerOnShaftWithMaterial / Math.pow(ratedSpeed, 3);
        let fowz = 9550 * powerOnShaftMin / Math.pow(ratedSpeed, 3); 

        let lineFow0 = new PolynomialLine('fow0'); //pierwsza część wykresu fow - prosta
        lineFow0.min = xMin;
        lineFow0.max = xDivider;
        lineFow0.line.config.color = lineFowColor;
        lineFow0.chartScaling = true;
        lineFow0.polynomialOriginal = new Polynomial([0.3 * Mow, (-0.3 * Mow) / (ratedSpeed * xDivider)]).multiplyXByScalar(ratedSpeed);

        let lineFow1 = new PolynomialLine('fow1'); //druga część wykresu fow - parabola
        lineFow1.min = xDivider;
        lineFow1.max = xMax;
        lineFow1.line.config.color = lineFowColor;
        lineFow1.chartScaling = true;
        lineFow1.polynomialOriginal = new Polynomial([fow * Math.pow(p, 2), -2 * fow * p, fow]).multiplyXByScalar(ratedSpeed);

        let lineFowz0 = new PolynomialLine('fowz0'); //pierwsza część wykresu fowz - prosta
        lineFowz0.min = xMin;
        lineFowz0.max = xDivider;
        lineFowz0.line.config.color = lineFowzColor;
        lineFowz0.chartScaling = true;
        lineFowz0.polynomialOriginal = new Polynomial([0.3 * Mowz, (-0.3 * Mowz) / (ratedSpeed * xDivider)]).multiplyXByScalar(ratedSpeed);

        let lineFowz1 = new PolynomialLine('fowz1'); //druga część wykresu fowz - parabola
        lineFowz1.min = xDivider;
        lineFowz1.max = xMax;
        lineFowz1.line.config.color = lineFowzColor;
        lineFowz1.chartScaling = true;
        lineFowz1.polynomialOriginal = new Polynomial([fowz * Math.pow(p, 2), -2 * fowz * p, fowz]).multiplyXByScalar(ratedSpeed);

        graph.addLine(lineFow0);
        graph.addLine(lineFow1);
        graph.addLine(lineFowz0);
        graph.addLine(lineFowz1);
        graph.draw(); //przerysowuje i skaluje wykres
        graph.graph.xs.config = {start: xMin, end: xMax} //konfiguracja osi x
        //graph.graph.config.y.step = graph.graph.ys.config.end; //możliwa zmiana skalowania osi

        const rs = new VerticalLine(ratedSpeed / graphScale, 'ratedSpeedLine', 'red'); //pionowa linia kropkowana
        rs.type = 'ratedSpeedLine';
        graph.addPoint(rs);
    }

    getSelectedElementOfOption(elements) {
        for (let elementId in elements) {
            if (elements.hasOwnProperty(elementId) && elements[elementId].active == true)
                return elements[elementId].value;
        }

        return null;
    }

    translate(code, displayErrors = true) {
        let arg = {
            type: 'translate',
            code: code,
            displayErrors: displayErrors,
            out: ""
        }

        this.store.commit(arg);

        return arg.out;
    }
}

export {resistanceTorque};